<template>
  <section class="feature-area" v-loading="isLoading">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="section-title">
            <h3 class="title">KOEPLE</h3>
          </div>
        </div>
      </div>
      <div class="feature-post-slider position-relative">
        <span
          @click="featureSliderPrev"
          class="prev slick-arrow"
          style="display: block"
        >
          <i class="fal fa-angle-left"></i>
        </span>
        <slider v-if="post.length > 0" :settings="featureSliderSettings" ref="featureSlider">
          <template v-for="(data, index) in post">
            <div class="px-2" :key="index">
              <overlay-card stype="small" :datas="data" />
            </div>
          </template>
        </slider>
        <span
          @click="featureSliderNext"
          class="next slick-arrow"
          style="display: block"
        >
          <i class="fal fa-angle-right"></i>
        </span>
      </div>
    </div>
  </section>
</template>

<script>
import { getAds } from '@/api/placement';
import config from '@/config';
import Slider from "../Helpers/Slider.vue";
import OverlayCard from "../Utility/Cards/OverlayCard.vue";

export default {
  components: { Slider, OverlayCard },
  inject: ['dataWrapper', 'fetchStatus'],
  data() {
    return {
      // 初始化 post 为空数组
      post: [],
      featureSliderSettings: {
        slidesToShow: 4,
        slideToScroll: 1,
        arrows: false,
        responsive: [
          {
            breakpoint: 1025, // iPad 横屏最大宽度
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slideToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slideToScroll: 1,
            },
          },
        ],
      },
      isLoading: true,
    };
  },
  created() {
    this.fetchAdData();
  },
  watch: {
    'fetchStatus.isFetched': {
      handler(newVal) {
        if (newVal) {
          // this.post = Array.isArray(this.dataWrapper.articles) 
          //   ? this.dataWrapper.articles.filter(item => item.orgchannel === '2').slice(0, 6) 
          //   : [];
          // this.isLoading = false;
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    featureSliderNext() {
      this.$refs.featureSlider.next();
    },
    featureSliderPrev() {
      this.$refs.featureSlider.prev();
    },
    async fetchAdData() {
      try {
        const adsResponse = await getAds(config.AD_MIDDLESMALLSQUAREROLLINGBANNER);
        this.post = adsResponse.data || [];
        
        this.isLoading = false;
      } catch (error) {
        // 添加错误处理
        console.log('画廊广告加载失败:', error);
        this.isLoading = false;
      }
    }
  },
};
</script>

<style></style>
